/** Toolbar above cards: “My Agents” + search (meta can override copy) */
export const DEFAULT_MY_AGENTS_TOOLBAR = {
    title: 'My Agents',
    searchPlaceholder: 'Search',
};

export const DEFAULT_NO_SEARCH_RESULTS = 'No shortcuts match your search.';

/**
 * Filter opportunity shortcut cards by search text (eyebrow, title, description, button, id).
 * Empty / whitespace query returns all cards. Multi-word queries require every token to match somewhere in the card.
 */
export function filterOpportunityCardsByQuery(cards, rawQuery) {
    if (!Array.isArray(cards)) {
        return [];
    }
    const q = (rawQuery || '').trim().toLowerCase();
    if (!q) {
        return cards;
    }
    const tokens = q.split(/\s+/).filter(Boolean);
    return cards.filter((card) => {
        const haystack = [
            card.id,
            card.eyebrow,
            card.title,
            card.description,
            card.buttonLabel,
            card.isViewEnabled,
        ]
            .filter((v) => v !== undefined && v !== null)
            .map((v) => String(v).toLowerCase())
            .join(' ');
        return tokens.every((t) => haystack.includes(t));
    });
}

/** Figma 17556:156425 — opportunity grid card tokens */
export const CARD = {
    radius: 4,
    border: '1px solid rgba(59, 167, 104, 0.5)',
    bg: 'rgba(59, 167, 104, 0.04)',
    pad: 20,
    gap: 20,
    fixedHeight: 186,
    eyebrow: '#6B7280',
    title: '#2D2D4D',
    body: '#555555',
    green: '#3ba768',
};

/** Static media paths (served from app public / build copy) */
export const OPPORTUNITY_COCKPIT_MEDIA = {
    cardIcon: '/media/svg/oppertunityCardIcon.svg',
    topCardDecor: '/media/svg/oppertunityTopCard.svg',
    overviewLeadIcon: '/media/svg/oppertunityCardOPPs.png',
    contactMailboxArt: '/media/svg/mailSentOppertunity.svg',
};

/** Multi-line ellipsis (WebKit); parent flex items need minWidth: 0 */
export const lineClamp = (lines) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: lines,
    overflow: 'hidden',
    wordBreak: 'break-word',
});

export const ellipsisOneLine = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
};

export const ACTION_CARDS = [
    {
        id: 'all',
        eyebrow: 'Opportunity',
        title: 'All Opportunities',
        description: 'Browse every opportunity in one place and drill into details when you need to.',
        buttonLabel: 'View All',
        isButton: true,
        isRouterLink: true,
        routerLink: 'opportunities',
    },
    {
        id: 'myWork',
        eyebrow: 'Opportunity',
        title: 'My Work',
        description: 'See items assigned to you and stay on top of your queue.',
        buttonLabel: 'Open My Work',
        isButton: true,
        isRouterLink: true,
        routerLink: 'my-work',
    },
    {
        id: 'continue',
        eyebrow: 'Opportunity',
        title: 'Continue where I left off',
        description: 'Jump back to the last opportunity you were working on.',
        buttonLabel: 'Continue',
    },
    {
        id: 'recent',
        eyebrow: 'Opportunity',
        title: 'Recent Activity',
        description: 'Review the latest updates across opportunities and workflows.',
        buttonLabel: 'View activity',
    },
    {
        id: 'pricing',
        eyebrow: 'Opportunity',
        title: 'Pricing Opportunities',
        description: 'Focus on pricing and dollar-based opportunities that need attention.',
        buttonLabel: 'View pricing',
    },
    {
        id: 'contract',
        eyebrow: 'Opportunity',
        title: 'Contract Opportunities',
        description: 'Filter to non-pricing and contract-led opportunities.',
        buttonLabel: 'View contracts',
    },
    {
        id: 'realized',
        eyebrow: 'Opportunity',
        title: 'Realized Opportunities',
        description: 'Track opportunities that have been completed or realized.',
        buttonLabel: 'View realized',
    },
    {
        id: 'declined',
        eyebrow: 'Opportunity',
        title: 'Declined Opportunities',
        description: 'Review opportunities that were declined or closed out.',
        buttonLabel: 'View declined',
    }
];
